import { P2GDate } from '@parcel2go/peacock-legacy-core/dist/date';
import { useP2GMediaQueryDown } from '@parcel2go/peacock-legacy-core/dist/hooks/useP2GMediaQuery';
import { P2GTableBody } from '@parcel2go/peacock-legacy-core/dist/table/body';
import { P2GTableCell } from '@parcel2go/peacock-legacy-core/dist/table/cell';
import { P2GTableHead } from '@parcel2go/peacock-legacy-core/dist/table/header';
import { P2GTableRow } from '@parcel2go/peacock-legacy-core/dist/table/row';
import { P2GTable } from '@parcel2go/peacock-legacy-core/dist/table/table';
import { P2GTranslation } from '@parcel2go/peacock-legacy-resources/dist/translations';
import React from 'react';

import { TrackingEvent } from '../../services/api/index';
import { P2GTooltip } from '@parcel2go/peacock-legacy-core/dist/tooltip';

interface ITrackingType {
  stage: string,
  type: string
}

const TrackingType: React.FC<ITrackingType> = (props) => {

  const { stage, type } = props;

  if (type === 'Misc') {
    if (stage === "DroppedOff") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.DROPPEDOFF" />
    }
    if (stage === "Collected") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.COLLECTED" />
    }
    if (stage === "InTransit") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.INTRANSIT" />
    }
    if (stage === "AtDepot") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.ATDEPOT" />
    }
    if (stage === "DeliveryScheduled") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.DELIVERYSCHEDULED" />
    }
    if (stage === "Delivered") {
      return <P2GTranslation translation="TRACKING.RESULT.STAGE.DELIVERED" />
    }
  }

  return <P2GTranslation translation="TRACKING.RESULT.STAGE.TYPE" options={{ type: type }}>{type}</P2GTranslation>
}

interface ITrackingEventsTable {
  parcelNumber: string,
  events: TrackingEvent[]
}

export const TrackingEventsTable: React.FC<ITrackingEventsTable> = (props) => {

  const isBreak = useP2GMediaQueryDown('xs');

  return (
    <P2GTable>
      <P2GTableHead>
        <P2GTableRow>
          <P2GTableCell><P2GTranslation translation="TRACKING.RESULT.TABLE.TIMESTAMP" /></P2GTableCell>
          {!isBreak &&
            <P2GTableCell><P2GTranslation translation="TRACKING.RESULT.TABLE.DETAIL" /></P2GTableCell>
          }
          <P2GTableCell><P2GTranslation translation="TRACKING.RESULT.TABLE.TYPE" /></P2GTableCell>
        </P2GTableRow>
      </P2GTableHead>
      <P2GTableBody>
        {props.events.map(e => {
          return <P2GTableRow key={`${props.parcelNumber}${e.timestamp}${e.code}`}>
            <P2GTableCell>
              <P2GTooltip title={e.timestamp}>
                <P2GDate date={new Date(e.timestamp)} />
              </P2GTooltip>
            </P2GTableCell>
            {!isBreak &&
              <P2GTableCell>{e.description}</P2GTableCell>
            }
            <P2GTableCell><TrackingType stage={e.stage} type={e.type} /></P2GTableCell>
          </P2GTableRow>
        })}
      </P2GTableBody>
    </P2GTable>
  );
}
